import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a29b6430"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "address" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "address-head" }),
  /*#__PURE__*/_createElementVNode("div", { class: "address-body" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "address-city" }),
    /*#__PURE__*/_createElementVNode("span", { class: "address-content" })
  ])
], -1))
const _hoisted_2 = { class: "periods" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "periods-head" }, "時間：", -1))
const _hoisted_4 = { class: "periods-body" }
const _hoisted_5 = { style: {"font-weight":"bold"} }
const _hoisted_6 = {
  key: 0,
  style: {"font-weight":"bold"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_JobListItemTemplate = _resolveComponent("JobListItemTemplate")!

  return (_openBlock(), _createBlock(_component_JobListItemTemplate, _normalizeProps(_guardReactiveProps({ job: _ctx.job, personalJobType: _ctx.personalJobType })), _createSlots({
    body: _withCtx(() => [
      _hoisted_1
    ]),
    _: 2
  }, [
    (_ctx.personalJobType === 3)
      ? {
          name: "entity",
          fn: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.job.entityInfo.time), 1),
                (_ctx.job.entityInfo.hasMutiplePeriods)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, "..."))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        }
      : undefined
  ]), 1040))
}